// extracted by mini-css-extract-plugin
module.exports = {"PrivacyPolicy":"styles_PrivacyPolicy__1yQKN","PrivacyPolicy-content":"styles_PrivacyPolicy-content__29nac","PrivacyPolicy-paragraph":"styles_PrivacyPolicy-paragraph__3Eu8-"};